import React, { useCallback, useEffect, useMemo } from 'react';
import { Button, Grid } from '@mui/material';
import TextField from 'libs/formik_fields/TextField';
import { makeStyles } from '@mui/styles';
import { useNavigate } from 'react-router-dom';
import * as yup from 'yup';
import FormikFormWrapper from 'libs/formik_fields/FormikFormWrapper';
import SelectField from '../../libs/formik_fields/SelectField';
import { cities, countries, states } from '../../data/cities';
import { LoadingButton } from '@mui/lab';
import SingleFileUploadField from '../../libs/formik_fields/SingleFileUploadField';

const emptyInstitute = {
    name: '',
    address: '',
    country: null,
    city: null,
    state: null,
    logo: { url: '', key: '', new: false, loading: false }
};

const instituteSchema = yup.object().shape({
    name: yup.string().required('Please enter name of institute.'),
    address: yup.string().required('Please enter address of institute.'),
    country: yup.mixed().required('Please select country of institute.'),
    state: yup.mixed().required('Please select state of institute.'),
    city: yup.mixed().required('Please select city of institute.')
});

const useStyles = makeStyles((theme) => ({
    button: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1)
    }
}));

const InstituteFormContent = (formik) => {
    const {
        values: { state, city },
        setFieldValue,
        isSubmitting
    } = formik;

    const cityOptions = useMemo(() => {
        if (state) {
            const filteredCities = cities.filter((city) => city.state === state.value);
            const obj = filteredCities.find((cityObj) => cityObj.value === city?.value);
            if (!obj) {
                setFieldValue('city', null);
            }
            return filteredCities;
        }
        return [];
    }, [state]);

    // useEffect(() => {
    //     setFieldValue('bankAccountName', name);
    // }, [name]);

    const navigate = useNavigate();

    const handleBack = useCallback(() => {
        navigate('/institute/list');
    }, [navigate]);

    const classes = useStyles();

    return (
        <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
                <TextField name="name" label="Name*" />
                <TextField name="address" label="Address*" rows={4.1} multiline />
                <SingleFileUploadField name="logo" label="Logo image" accept="image/*" fileType="image" />
            </Grid>
            <Grid item xs={12} md={6}>
                <SelectField name="country" options={countries} labelKey="label" valueKey="value" placeholder="Country*" />
                <SelectField name="state" options={states} labelKey="label" valueKey="value" placeholder="State*" />
                <SelectField name="city" options={cityOptions} labelKey="label" valueKey="value" placeholder="City*" />

                {/* <SwitchField name="active" label="Active" /> */}
            </Grid>
            <Grid item xs={12} style={{ paddingTop: 0 }}>
                <LoadingButton
                    type="submit"
                    variant="contained"
                    color="primary"
                    disableElevation
                    loading={isSubmitting}
                    loadingPosition="center"
                >
                    Save
                </LoadingButton>
                <Button
                    variant="outlined"
                    color="secondary"
                    sx={{
                        ml: 1
                    }}
                    onClick={handleBack}
                >
                    Back
                </Button>
            </Grid>
        </Grid>
    );
};

function InstituteForm({ handleSubmit, initialValues }) {
    return (
        <FormikFormWrapper
            initialValues={initialValues ?? emptyInstitute}
            onSubmit={handleSubmit}
            validationSchema={instituteSchema}
            FormContent={InstituteFormContent}
        />
    );
}

export default InstituteForm;
